"use strict";

var _regeneratorRuntime = require("/Users/xavieraguas/Documents/Github_Repository/IVAN/Landing-Page-Ecommerce-Assistant/node_modules/@babel/runtime/regenerator/index.js");

var _asyncToGenerator = require("/Users/xavieraguas/Documents/Github_Repository/IVAN/Landing-Page-Ecommerce-Assistant/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadExternalAttractInteraction = void 0;

var Attractor_1 = require("./Attractor");

function loadExternalAttractInteraction(_x) {
  return _loadExternalAttractInteraction.apply(this, arguments);
}

function _loadExternalAttractInteraction() {
  _loadExternalAttractInteraction = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(tsParticles) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return tsParticles.addInteractor("externalAttract", function (container) {
              return new Attractor_1.Attractor(container);
            });

          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _loadExternalAttractInteraction.apply(this, arguments);
}

exports.loadExternalAttractInteraction = loadExternalAttractInteraction;